module.exports = __webpack_public_path__ + "static/Header-96a1853810aecc84a01895c1984ca538.jpeg";